import React, { useEffect, useState } from 'react'
import { useEthers, shortenAddress, useLookupAddress } from '@usedapp/core'
import { Colors } from '../../global/styles'
import styled from 'styled-components'

import { AccountModal } from './AccountModal'

import { Tooltip, OverlayTrigger, Modal, Button } from 'react-bootstrap'
import WalletConnectProvider from '@walletconnect/web3-provider'



export const AccountButton = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { account, deactivate, activate, activateBrowserWallet } = useEthers()
  const ens = useLookupAddress(account)
  const [showModal, setShowModal] = useState(false)

  const [activateError, setActivateError] = useState('')
  const { error } = useEthers()
  useEffect(() => {
    if (error) {
      setActivateError(error.message)
    }
  }, [error])

  // const activate = async () => {
  //   setActivateError('')
  //   activateBrowserWallet()
  // }

  async function onConnect() {
    try {
      const provider = new WalletConnectProvider({
        infuraId: '9a89a489317b4dd4a4d7a4b3dfe42841',

      })
      await provider.enable()
      await activate(provider)
      handleClose();
    } catch (error) {
      console.error(error)
      handleClose();
    }
  }

  async function onMetamaskConnect() {
    setActivateError('');
    activateBrowserWallet();
    handleClose();

  }

  

  return (
    <Account>
      <ErrorWrapper>{activateError}</ErrorWrapper>
      {showModal && <AccountModal setShowModal={setShowModal} />}
      {account ? (
        <>
          <LoginButton  variant="outline-secondary" onClick={() => deactivate()}>Disconnect</LoginButton>
        </>
      ) : (
          <LoginButton variant="outline-primary" onClick={handleShow}>
          Connect
        </LoginButton>
      )}
        <>

      <Modal show={show} onHide={handleClose}>
  
        
          <ConnectButton variant="outline-primary" onClick={onConnect}>
            <WalletConnectIcon/>  
            WalletConnect
          </ConnectButton>
          <ConnectButton variant="outline-primary" onClick={onMetamaskConnect}>
          <MetamaskIcon/>  

            MetaMask
          </ConnectButton>
      </Modal>
    </>
    </Account>
  )
}

const ConnectButton = styled(Button)`
  display: flex;
  margin:0.5em;
  justify-content: center;
  align-items: center;
`

const ErrorWrapper = styled.div`
  color: #ff3960;
  margin-right: 40px;
  margin-left: 40px;
  overflow: auto;
`

const Account = styled.div`
  display: flex;
  align-items: center;
  padding-right:8px;
`

const LoginButton = styled(Button)`
`

const WalletConnectIcon = styled.div`
  background-image : url(./walletconnectlogo.png);
  background-size: contain;
  height: 15px;
  width: 24px;
`

const MetamaskIcon = styled.div`
  background-image : url(./metamask.png);
  background-size: contain;
  height: 25px;
  width: 25px;
`

const AccountLabel = styled(Button)`
  height: 32px;
  margin-right: -40px;
  padding-right: 40px;
  padding-left: 8px;
  background-color: ${Colors.Yellow[100]};
  font-size: 12px;
`
